import { Content } from '@leverege/ui-elements'
import React, { useMemo } from 'react'

import AnalyticsContext from '../analytics/AnalyticsContext'
import OccupancyAreaChart from './components/OccupancyAreaChart'

import useStoreTrafficEvents from '../hooks/useStoreTrafficEvents'
import S from './RoomOccupancy.css'
import OccupancyCard from './components/OccupancyCard'

export default function RoomOccupancy( props ) {
  const { parentItem } = props

  return (
    <AnalyticsContext store={parentItem}>
      <WithRoomOccupancyContext {...props} />
    </AnalyticsContext>
  )
}

function WithRoomOccupancyContext( props ) {
  const { data } = props

  const { result } = useStoreTrafficEvents( props )

  const featureDeviceMap = useMemo( () => {
    return data?.items?.reduce( ( prev, curr ) => {
      const featuresMap = curr.data?.metadata?.analytics?.occupancy
      if ( featuresMap ) {
        Object
          .keys( featuresMap )
          .forEach( ( f ) => {
            prev[f] = {
              deviceId : curr.id,
              name : curr.data?.name
            }
          } )
      }
      return prev
    }, {} )
  }, [ data ] )

  const nMappedEvents = useMemo( () => {
    return result?.items.reduce( ( prev, curr ) => {
      if ( featureDeviceMap[curr.data.featureName] ) {
        if ( prev[featureDeviceMap[curr.data.featureName].deviceId] ) {
          prev[featureDeviceMap[curr.data.featureName].deviceId].items.push( curr )
        } else {
          prev[featureDeviceMap[curr.data.featureName].deviceId] = {
            deviceId : featureDeviceMap[curr.data.featureName].deviceId,
            name : featureDeviceMap[curr.data.featureName].name,
            items : [ curr ]
          }
        }
      }

      return prev
    }, {} )
  }, [ result, featureDeviceMap ] )

  const mappedEvents = Object.values( nMappedEvents )

  return (
    <Content>
      <Content.Area className={S.area}>
        <div className={S.grid}>
          <OccupancyCard {...props} />
          {mappedEvents.map( events => (
            <OccupancyAreaChart key={events.deviceId} events={events} {...props} />
          ) )}
        </div>
      </Content.Area>
    </Content>
  )
}
